import {useContext, useEffect, useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import {useFlowOverview} from './useOverview';
import {PageContext} from '../../../../helpers/context';
import {parseUrlParams} from '../../../../helpers';
import {useGatedQuery} from './useGatedQuery';
import {fetchFlows} from '../../../../requests/queries/flows';

export const useFlowsLogic = ({isFilter = false, enabled = false}) => {
  const {userDetails} = useSelector(state => state?.auth);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const companyId = userDetails?.company?.id;

  const params = useMemo(
    () => ({
      company_id: companyId,
      limit: isFilter ? 1000 : limit,
      page: currentPage,
    }),
    [currentPage, limit, companyId, isFilter],
  );

  const {data: easyFlows, isLoading: isLoadingFlows} = useGatedQuery(
    ['e-flows', {params}],
    () => fetchFlows({params}),
    {
      retry: false,
      enabled,
    },
  );

  const flows = useMemo(
    () =>
      (!isLoadingFlows && easyFlows && {flows: easyFlows?.rows}) || {flows: []},
    [easyFlows, isLoadingFlows],
  );

  const pageClick = selected => {
    setCurrentPage(selected);
  };

  const {
    TOTAL_EVENTS,
    TOTAL_BLOCKED,
    TOTAL_ALLOWED,
    TOTAL_PENDING,
    isLoading: overviewLoading,
  } = useFlowOverview({
    enabled: !isLoadingFlows && easyFlows?.rows?.length > 0,
  });

  const {setPageName} = useContext(PageContext);
  useEffect(() => {
    setPageName('easydetect');
  }, [setPageName]);

  useEffect(() => {
    const apiParams = parseUrlParams();
    apiParams.limit = limit;

    const searchParams = new URLSearchParams(document.location.search);
    const pageParam = searchParams.get('page');
    if (pageParam) {
      setCurrentPage(parseInt(pageParam));
      apiParams.page = parseInt(pageParam);
    } else {
      apiParams.page = currentPage;
    }
  }, [currentPage, limit]);

  const {manageFlows} =
    useMemo(() => userDetails?.permissions?.detectPermissions, [userDetails]) ||
    {};
  return {
    pageClick,
    manageFlows,
    flows,
    TOTAL_EVENTS,
    TOTAL_BLOCKED,
    TOTAL_ALLOWED,
    TOTAL_PENDING,
    isLoadingFlows,
    setLimit,
    overviewLoading,
    easyFlows,
    limit,
    currentPage,
    companyId: userDetails?.company?.id,
  };
};
